
import React from "react";
import './ErrorModal.scss';
import { DialogContent, Dialog, Button } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import translate from "../../../../i18n/translate";

const ErrorModal = ({ errorCode, setErrorCode }: any) => {

  const notificationMessage = () => {
    if(errorCode.toString() === "4") {
      return translate("twt_max_multi_window_error_message")
    } else if(errorCode.toString() === "0") {
      return translate("twt_max_capacity_error_message")
    }
  }

  return (
    <Dialog open={true}>
        <div className="error-head">
          <div className="error-modal-title">{translate("twt_talk_with_teacher_title")}</div>
          <IconButton aria-label="delete" color="primary" onClick={() => setErrorCode('')}>
            <CloseIcon className="close-icon"></CloseIcon>
          </IconButton>
        </div>
      <DialogContent id="simple-dialog-title">{notificationMessage()}</DialogContent>
      <div className="footer">
        <Button color="primary" variant="contained" size="medium"  className="session-view-button" onClick={() => setErrorCode('')}>{translate("twt_class_policy_ok")}</Button>
      </div>
    </Dialog> 
  );
}

export default ErrorModal